/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import WarehouseSyncModel from 'cio/models/warehouse-sync';
import {
  getWarehouseDestinationName,
  WAREHOUSE_SCHEMA_V4_OPTIONS,
  WarehouseDataOption,
  WarehouseDataOptionID,
  WarehouseDestination,
} from 'cio/utils/warehouse';
import ApiErrorsService from 'cio/services/api-errors';
import AlertsService from 'cio/services/alerts';
import AnalyticsService from 'cio/services/analytics';

interface WarehouseSyncDetailsArgs {
  model: WarehouseSyncModel;
  destination: WarehouseDestination;
  readOnly: boolean;
  isShowingPeopleSyncDisabledAlert: boolean;
  isShowingOutputsSyncDisableAlert: boolean;
  isShowingSubjectsSyncDisableAlert: boolean;
  toggleSchemaVersionUpdateModal: () => unknown;
}

export default class WarehouseSyncDetails extends Component<WarehouseSyncDetailsArgs> {
  @service alerts!: AlertsService;
  @service apiErrors!: ApiErrorsService;
  @service analytics!: AnalyticsService;
  WarehouseDataOptionID = WarehouseDataOptionID;

  get options(): WarehouseDataOption[] {
    return WAREHOUSE_SCHEMA_V4_OPTIONS;
  }

  get destinationName(): string {
    return getWarehouseDestinationName(this.args.destination);
  }

  updateOptionTask = dropTask(async (key: keyof WarehouseSyncModel, value: boolean) => {
    this.apiErrors.clear();

    try {
      this.args.model.set('updateType', 'settings');
      this.args.model.set(key, value);

      await this.args.model.save();
      this.alerts.success('warehouse-sync.update', 'Updated your warehouse sync settings');
      this.analytics.track('warehouse', value ? 'export_enabled' : 'export_disabled', {
        model: this.args.model,
        exportType: key,
      });
    } catch (e) {
      this.apiErrors.report(e);
    }
  });
}
